export async function apiError<T extends object = any>(error: any) {
	const errors: Record<keyof T, string> = await error?.response
		?.json()
		.then((err: any) => {
			const errors = err?.errors;
			return errors;
		});

	return errors;
}
